var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgMusicNote = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 5.67874V16.3544C25.2671 15.524 24.1947 15.0002 23 15.0002C20.7909 15.0002 19 16.7911 19 19.0002C19 21.2093 20.7909 23.0002 23 23.0002C25.2091 23.0002 27 21.2094 27 19.0002V19.0002V5.41924C27 4.38194 25.9724 3.65774 24.9955 4.00662L12.9955 8.29234C12.3985 8.50555 12 9.07103 12 9.70495V20.3544C11.2671 19.524 10.1947 19.0002 9 19.0002C6.79086 19.0002 5 20.7911 5 23.0002C5 25.2093 6.79086 27.0002 9 27.0002C11.2091 27.0002 13 25.2094 13 23.0002V23.0002V10.3216L26 5.67874Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgMusicNote);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/music-note.e0378acea81bf118a5f3b8e32bc0de4b.svg";